// frontend/src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import AdminRoute from './auth/AdminRoute';
import PermisoRoute from './auth/PermisoRoute';
import RecepcionRoute from './auth/RecepcionRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PoliticaPrivacidadPage from './pages/PoliticaPrivacidadPage';
import TerminosPage from './pages/TerminosPage';
import EncuestaPublicaPage from './pages/Encuesta/EncuestaPublicaPage';
import EncuestaResultadosPage from './pages/Encuesta/EncuestaResultadosPage';
import EncuestaSatisfaccionPage from './pages/EncuestaSatisfaccionPage';
import MainLayout from './components/MainLayout';
import AtencionTracker from './components/recepcion/AtencionTracker';

import HomePage from './pages/HomePage';
import GestionBackups from "./pages/GestionBackups";
import ListadoClientes from './pages/RTI/ListadoClientes';
import VistaDetalladaCliente from './components/VistaDetalladaCliente';
import ListadoTramitesRTI from './pages/RTI/ListadoTramitesRTI';
import ListadoTramitesUnificado from './pages/Tramites/ListadoTramitesUnificado';
import FormularioIniciarTramiteRTI from './components/RTI/FormularioIniciarTramiteRTI';
import ModalRegistrarCliente from "./components/ModalRegistrarCliente";
import VistaDetalladaTramite from "./components/VistaDetalladaTramite";
import ListadoClientesInactivos from "./pages/RTI/ListadoClientesInactivos";
import ImportarClientesAnses from "./pages/RTI/ImportarClientesAnses";
import ListadoMedicos from "./pages/RTI/ListadoMedicos";
import CalendarioPage from "./pages/RTI/CalendarioPage";
import ListadoGastoMedico from './pages/RTI/ListadoGastosMedicos';
import ReportesGastos from './pages/RTI/ReportesGastos';
import ReportesTramites from './pages/ReportesTramites';
import ReportesTramitesART from './pages/ART/ReportesTramitesART';
import ReportesTramitesRTI from './pages/RTI/ReportesTramitesRTI';
import ReportesReferencias from './pages/ReportesReferencias';
import ReportesRecepcion from "./pages/Recepcion/ReportesRecepcion";
import ReportesRecepcionPro from "./pages/Recepcion/ReportesRecepcionPro";
import ReportesRecepcionHistoricas from "./pages/Recepcion/ReportesRecepcionHistoricas";
import ReportesRecepcionBot from "./pages/Recepcion/ReportesRecepcionBot";
import AdminUsuariosPage from './pages/AdminUsuariosPage';
import AdminLogsPage from './pages/AdminLogsPage';
import AdminDatosMaestrosPage from './pages/AdminDatosMaestrosPage';
import AdminDatosMaestrosListaPage from './pages/AdminDatosMaestrosListaPage';
import AdminEmailPage from './pages/AdminEmailPage';
import AdminWhatsAppPage from './pages/AdminWhatsAppPage';
import CasillaCorreosPage from './pages/CasillaCorreosPage';
import NotificacionesPage from './pages/NotificacionesPage';
import ConfiguracionNotificacionesPage from './pages/ConfiguracionNotificacionesPage';
import MiPerfilPage from './pages/MiPerfilPage';
import ARTInicio from './pages/ART/ARTInicio';
import FormularioIniciarTramiteART from './pages/ART/FormularioIniciarTramiteART';
import ListadoTramitesART from './pages/ART/ListadoTramitesART';
import VistaDetalladaTramiteART from './pages/ART/VistaDetalladaTramiteART';
import CalendarioPageART from './pages/ART/CalendarioPageART';
import RTIInicio from './pages/RTI/RTIInicio';
import AtencionPage from './pages/Recepcion/AtencionPage';
import ImportarHistorialLaboralPage from './pages/ImportarHistorialLaboralPage';
import GenerarDocumentosPage from './pages/GenerarDocumentosPage';
import TramiteLegacyRedirect from './components/TramiteLegacyRedirect';
import FeedbackPage from './pages/FeedbackPage';
import ChatPage from './pages/ChatPage';
import SeguimientoExpedientesPage from './pages/SeguimientoExpedientesPage';
import TurnosAnsesPage from './pages/Anses/TurnosAnsesPage';
import ReportesAnsesPage from './pages/Anses/ReportesAnsesPage';
import ImportacionLotePage from './pages/Importacion/ImportacionLotePage';
import SeguimientoExpedienteDetalle from './pages/SeguimientoExpedienteDetalle';
import AdminAnsesSearchPage from './pages/AdminAnsesSearchPage';
import TurneroPage from './pages/Recepcion/TurneroPage';
import PanelDiario from './pages/Recepcion/PanelDiario';
import HistoricoTurnosPage from './pages/Recepcion/HistoricoTurnosPage';
import VistaDetalladaAtencion from './pages/Recepcion/VistaDetalladaAtencion';
import ConfiguracionTurneroPage from './pages/ConfiguracionTurneroPage';
import VistaDetalladaTramiteJubilacion from './pages/Jubilacion/VistaDetalladaTramiteJubilacion';
import FormularioIniciarTramiteJubilacion from './components/Jubilacion/FormularioIniciarTramiteJubilacion';
import VistaDetalladaTramitePuam from './pages/Puam/VistaDetalladaTramitePuam';
import FormularioIniciarTramitePuam from './components/Puam/FormularioIniciarTramitePuam';
import VistaDetalladaTramiteGenerico from './pages/Generico/VistaDetalladaTramiteGenerico';
import FormularioIniciarTramiteGenerico from './components/Generico/FormularioIniciarTramiteGenerico';
import VistaDetalladaTramitePlanPago from './pages/PlanPago/VistaDetalladaTramitePlanPago';
import FormularioIniciarTramitePlanPago from './components/PlanPago/FormularioIniciarTramitePlanPago';
import VistaDetalladaTramiteReajuste from './pages/Reajuste/VistaDetalladaTramiteReajuste';
import FormularioIniciarTramiteReajuste from './components/Reajuste/FormularioIniciarTramiteReajuste';
import VistaDetalladaTramiteReconocimiento from './pages/Reconocimiento/VistaDetalladaTramiteReconocimiento';
import FormularioIniciarTramiteReconocimiento from './components/Reconocimiento/FormularioIniciarTramiteReconocimiento';
import VistaDetalladaTramitePnc from './pages/Pnc/VistaDetalladaTramitePnc';
import FormularioIniciarTramitePnc from './components/Pnc/FormularioIniciarTramitePnc';
import VistaDetalladaTramiteAmparoPnc from './pages/AmparoPnc/VistaDetalladaTramiteAmparoPnc';
import FormularioIniciarTramiteAmparoPnc from './components/AmparoPnc/FormularioIniciarTramiteAmparoPnc';
import VistaDetalladaTramitePension from './pages/Pension/VistaDetalladaTramitePension';
import FormularioIniciarTramitePension from './components/Pension/FormularioIniciarTramitePension';
import VistaDetalladaTramiteGanancias from './pages/Ganancias/VistaDetalladaTramiteGanancias';
import FormularioIniciarTramiteGanancias from './components/Ganancias/FormularioIniciarTramiteGanancias';
import VistaDetalladaTramiteMinusvalia from './pages/Minusvalia/VistaDetalladaTramiteMinusvalia';
import FormularioIniciarTramiteMinusvalia from './components/Minusvalia/FormularioIniciarTramiteMinusvalia';
import VistaDetalladaTramiteDeclaratoria from './pages/Declaratoria/VistaDetalladaTramiteDeclaratoria';
import FormularioIniciarTramiteDeclaratoria from './components/Declaratoria/FormularioIniciarTramiteDeclaratoria';
import VistaDetalladaTramiteAmparo from './pages/Amparo/VistaDetalladaTramiteAmparo';
import FormularioIniciarTramiteAmparo from './components/Amparo/FormularioIniciarTramiteAmparo';
import PantallaInformativaPage from './pages/Recepcion/PantallaInformativaPage';
import ConfiguracionPantallaInformativaPage from './pages/Recepcion/ConfiguracionPantallaInformativaPage';
import ListadoACobrar from './pages/Listados/ListadoACobrar';
import ListadoAltas from './pages/Listados/ListadoAltas';
import ListadoDeudores from './pages/Listados/ListadoDeudores';
import ListadoALiquidar from './pages/Listados/ListadoALiquidar';
import ListadoParaAprobar from './pages/Listados/ListadoParaAprobar';
import ListadoCargarJauregui from './pages/Listados/ListadoCargarJauregui';
import ListadoVolverAContactar from './pages/Listados/ListadoVolverAContactar';
import ListadoPlanillaHistorica from './pages/Listados/ListadoPlanillaHistorica';
import BusquedaGlobalMobile from './components/mobile/BusquedaGlobalMobile';

function App() {
    return (
        <Router>
            <Routes>
                {/*
                  Pantalla informativa: el TV de la sala de espera. Es un kiosco: va fuera de
                  AuthProvider, ProtectedRoute y MainLayout porque no muestra nada del sistema y no
                  depende de una sesión (se autentica con la clave del link). Fuera de AuthProvider
                  importa: si en ese navegador quedó un token vencido, AuthProvider redirigiría el TV
                  a /login al recargar.
                */}
                <Route path="/tv-screen" element={<PantallaInformativaPage />} />
                <Route path="/*" element={<RutasDelSistema />} />
            </Routes>
        </Router>
    );
}

function RutasDelSistema() {
    return (
        <AuthProvider>
            <Routes>
                {/* Rutas Públicas */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
                <Route path="/terminos" element={<TerminosPage />} />
                {/*
                  Encuesta de satisfacción: se responde desde un link de WhatsApp, sin login.
                  Va acá arriba, fuera de ProtectedRoute y de MainLayout, porque quien la abre
                  puede no tener sesión y no tiene que ver el menú del sistema. Los resultados
                  son otra ruta, /encuesta/resultados, y esa sí está adentro del área protegida.
                */}
                <Route path="/encuesta" element={<EncuestaPublicaPage />} />
                <Route path="/satisfaccion/:idTramite" element={<EncuestaSatisfaccionPage />} />

                {/* Rutas Protegidas */}
                <Route
                    path="/*"
                    element={
                        <ProtectedRoute>
                            <MainLayout>
                                <AtencionTracker />
                                <Routes>
                                    {/* HomePage interna en /home */}
                                    <Route path="/home" element={<HomePage />} />

                                    {/* Rutas de Trámites RTI */}
                                    <Route path="/tramites" element={<ListadoTramitesUnificado />} />
                                    <Route path="/rti/tramites" element={<ListadoTramitesRTI />} />
                                    <Route path="/rti/tramites/:idTramite" element={<VistaDetalladaTramite />} />
                                    <Route path="/rti/tramites/iniciar-tramite" element={<FormularioIniciarTramiteRTI />} />
                                    <Route path="/rti/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteRTI />} />

                                    {/* Compatibilidad legacy de RTI/ART */}
                                    <Route path="/tramites/:idTramite" element={<TramiteLegacyRedirect />} />
                                    <Route path="/tramites/iniciar-tramite" element={<Navigate to="/rti/tramites/iniciar-tramite" replace />} />
                                    <Route path="/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteRTI />} />

                                    {/* Rutas de Trámites ART */}
                                    <Route path="/art/tramites" element={<ListadoTramitesART />} />
                                    <Route path="/art/tramites/:idTramite" element={<VistaDetalladaTramiteART />} />
                                    <Route path="/art/tramites/iniciar-tramite" element={<FormularioIniciarTramiteART />} />
                                    <Route path="/art/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteART />} />
                                    <Route path="/art/calendario" element={<CalendarioPageART />} />

                                    {/* Rutas de Trámites Jubilación (listado y home centralizados en /tramites) */}
                                    <Route path="/jubilacion/tramites/:idTramite" element={<VistaDetalladaTramiteJubilacion />} />
                                    <Route path="/jubilacion/tramites/iniciar-tramite" element={<FormularioIniciarTramiteJubilacion />} />
                                    <Route path="/jubilacion/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteJubilacion />} />

                                    {/* Rutas de Trámites PUAM (listado y home centralizados en /tramites) */}
                                    <Route path="/puam/tramites/:idTramite" element={<VistaDetalladaTramitePuam />} />
                                    <Route path="/puam/tramites/iniciar-tramite" element={<FormularioIniciarTramitePuam />} />
                                    <Route path="/puam/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramitePuam />} />

                                    {/* Rutas de Trámites Genéricos ("Otro trámite") */}
                                    <Route path="/generico/tramites/:idTramite" element={<VistaDetalladaTramiteGenerico />} />
                                    <Route path="/generico/tramites/iniciar-tramite" element={<FormularioIniciarTramiteGenerico />} />
                                    <Route path="/generico/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteGenerico />} />

                                    {/* Rutas de Trámites Plan de Pago 27.705 (listado y home centralizados en /tramites) */}
                                    <Route path="/plan-pago/tramites/:idTramite" element={<VistaDetalladaTramitePlanPago />} />
                                    <Route path="/plan-pago/tramites/iniciar-tramite" element={<FormularioIniciarTramitePlanPago />} />
                                    <Route path="/plan-pago/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramitePlanPago />} />

                                    {/* Rutas de Trámites Reajuste de Haberes (listado y home centralizados en /tramites) */}
                                    <Route path="/reajuste/tramites/:idTramite" element={<VistaDetalladaTramiteReajuste />} />
                                    <Route path="/reajuste/tramites/iniciar-tramite" element={<FormularioIniciarTramiteReajuste />} />
                                    <Route path="/reajuste/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteReajuste />} />

                                    {/* Rutas de Trámites Reconocimiento de Servicios (listado y home centralizados en /tramites) */}
                                    <Route path="/reconocimiento/tramites/:idTramite" element={<VistaDetalladaTramiteReconocimiento />} />
                                    <Route path="/reconocimiento/tramites/iniciar-tramite" element={<FormularioIniciarTramiteReconocimiento />} />
                                    <Route path="/reconocimiento/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteReconocimiento />} />

                                    {/* Rutas de Trámites PNC (listado y home centralizados en /tramites) */}
                                    <Route path="/pnc/tramites/:idTramite" element={<VistaDetalladaTramitePnc />} />
                                    <Route path="/pnc/tramites/iniciar-tramite" element={<FormularioIniciarTramitePnc />} />
                                    <Route path="/pnc/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramitePnc />} />

                                    {/* Rutas de Trámites Amparo PNC (listado y home centralizados en /tramites) */}
                                    <Route path="/amparo-pnc/tramites/:idTramite" element={<VistaDetalladaTramiteAmparoPnc />} />
                                    <Route path="/amparo-pnc/tramites/iniciar-tramite" element={<FormularioIniciarTramiteAmparoPnc key="PNC" />} />
                                    <Route path="/amparo-pnc/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteAmparoPnc key="PNC" />} />
                                    {/* Amparo Ley 16.986 (V256): variante de Amparo PNC, misma ficha y mismo formulario. */}
                                    <Route path="/amparo-ley-16986/tramites/:idTramite" element={<VistaDetalladaTramiteAmparoPnc />} />
                                    <Route path="/amparo-ley-16986/tramites/iniciar-tramite" element={<FormularioIniciarTramiteAmparoPnc key="LEY_16986" variante="LEY_16986" />} />
                                    <Route path="/amparo-ley-16986/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteAmparoPnc key="LEY_16986" variante="LEY_16986" />} />

                                    {/* Rutas de Trámites Pensión (listado y home centralizados en /tramites) */}
                                    <Route path="/pension/tramites/:idTramite" element={<VistaDetalladaTramitePension />} />
                                    <Route path="/pension/tramites/iniciar-tramite" element={<FormularioIniciarTramitePension />} />
                                    <Route path="/pension/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramitePension />} />

                                    {/* Rutas de Trámites de Impuesto a las Ganancias (listado y home centralizados en /tramites) */}
                                    <Route path="/ganancias/tramites/:idTramite" element={<VistaDetalladaTramiteGanancias />} />
                                    <Route path="/ganancias/tramites/iniciar-tramite" element={<FormularioIniciarTramiteGanancias />} />
                                    <Route path="/ganancias/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteGanancias />} />

                                    {/* Rutas de Trámites de Minusvalía (listado y home centralizados en /tramites) */}
                                    <Route path="/minusvalia/tramites/:idTramite" element={<VistaDetalladaTramiteMinusvalia />} />
                                    <Route path="/minusvalia/tramites/iniciar-tramite" element={<FormularioIniciarTramiteMinusvalia />} />
                                    <Route path="/minusvalia/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteMinusvalia />} />
                                    <Route path="/declaratoria/tramites/:idTramite" element={<VistaDetalladaTramiteDeclaratoria />} />
                                    <Route path="/declaratoria/tramites/iniciar-tramite" element={<FormularioIniciarTramiteDeclaratoria />} />
                                    <Route path="/declaratoria/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteDeclaratoria />} />
                                    {/* Amparo por mora ante ANSES (V239). Ojo: NO es /amparo-pnc,
                                        que es el amparo de PNC ante ANDIS y tiene sus propias rutas. */}
                                    <Route path="/amparo/tramites/:idTramite" element={<VistaDetalladaTramiteAmparo />} />
                                    <Route path="/amparo/tramites/iniciar-tramite" element={<FormularioIniciarTramiteAmparo />} />
                                    <Route path="/amparo/tramites/iniciar-tramite/:cuil" element={<FormularioIniciarTramiteAmparo />} />

                                    {/* Rutas de Clientes */}
                                    <Route path="/clientes" element={<ListadoClientes />} />
                                    <Route path="/clientes/inactivos" element={<ListadoClientesInactivos />} />
                                    <Route path="/clientes/importar-anses" element={<ImportarClientesAnses />} />
                                    <Route path="/clientes/registrar" element={<ModalRegistrarCliente />} />
                                    <Route path="/clientes/vista-detallada/:cuil" element={<VistaDetalladaCliente />} />

                                    {/* Otras Rutas */}
                                    <Route path="/medicos" element={<ListadoMedicos />} />
                                    <Route path="/calendario" element={<CalendarioPage />} />

                                    <Route path="/gastos" element={<ListadoGastoMedico />} />

                                    <Route path="/rti" element={<RTIInicio />} />
                                    <Route path="/art" element={<ARTInicio />} />
                                    <Route path="/recepcion" element={<PanelDiario />} />
                                    <Route path="/recepcion/turnero" element={<TurneroPage />} />
                                    <Route path="/recepcion/atencion" element={<AtencionPage />} />
                                    <Route path="/recepcion/historico" element={<HistoricoTurnosPage />} />
                                    {/* Configuración del TV de la sala de espera; el TV en sí es /tv-screen, arriba. */}
                                    <Route
                                        path="/recepcion/pantalla-informativa"
                                        element={<PermisoRoute permiso="turnero.config"><ConfiguracionPantallaInformativaPage /></PermisoRoute>}
                                    />
                                    <Route path="/anses/turnos" element={<TurnosAnsesPage />} />
                                    <Route path="/anses/reportes" element={<ReportesAnsesPage />} />
                                    <Route path="/admin/importaciones" element={<ImportacionLotePage />} />
                                    <Route path="/recepcion/atencion/:nroTurno" element={<VistaDetalladaAtencion />} />
                                    <Route path="/atencion/:nroTurno" element={<VistaDetalladaAtencion />} />
                                    <Route path="/atención/:nroTurno" element={<VistaDetalladaAtencion />} />
                                    <Route path="/tramites/nuevo" element={<FormularioIniciarTramiteRTI />} />
                                    <Route path="/mi-perfil" element={<MiPerfilPage />} />
                                    <Route path="/correos" element={<CasillaCorreosPage />} />
                                    {/* Búsqueda global mobile: vista propia a pantalla completa, ver components/mobile/ */}
                                    <Route path="/busqueda" element={<BusquedaGlobalMobile />} />
                                    <Route path="/notificaciones" element={<NotificacionesPage />} />
                                    <Route path="/configuraciones/notificaciones" element={<ConfiguracionNotificacionesPage />} />
                                    {/* Chat interno: solo desde el icono del header; estas rutas redirigen al inicio */}
                                    <Route path="/chat-interno" element={<Navigate to="/" replace />} />
                                    <Route path="/chat-interno/contactos" element={<Navigate to="/" replace />} />

                                    {/* Herramientas */}
                                    <Route path="/herramientas/documentos" element={<GenerarDocumentosPage />} />
                                    <Route path="/herramientas/historial-laboral" element={<ImportarHistorialLaboralPage />} />
                                    <Route path="/herramientas/seguimiento-expedientes" element={<SeguimientoExpedientesPage />} />
                                    <Route path="/herramientas/seguimiento-expedientes/cliente/:cuil" element={<SeguimientoExpedienteDetalle />} />
                                    <Route path="/herramientas/feedback" element={<FeedbackPage />} />
                                    <Route path="/herramientas/feedback/:ticketId" element={<FeedbackPage />} />
                                    <Route path="/herramientas/chat" element={<ChatPage />} />
                                    <Route path="/chat" element={<ChatPage />} />
                                    {/* Resultados de la encuesta de satisfacción: sólo PROGRAMADOR. */}
                                    <Route
                                        path="/encuesta/resultados"
                                        element={
                                            <PermisoRoute permiso="encuesta.resultados">
                                                <EncuestaResultadosPage />
                                            </PermisoRoute>
                                        }
                                    />

                                    {/* Listados (cobranzas + a liquidar) */}
                                    {/* Tramo previo a "A liquidar": las carpetas pasadas a cargar el calculo (V244). */}
                                    <Route path="/listados/cargar-jauregui" element={<PermisoRoute permiso="listados.ver"><ListadoCargarJauregui /></PermisoRoute>} />
                                    <Route path="/listados/volver-a-contactar" element={<PermisoRoute permiso="listados.ver"><ListadoVolverAContactar /></PermisoRoute>} />
                                    {/* key por origen: las dos rutas montan el mismo componente y React lo reutilizaba, con los
                                        filtros y las filas de la otra solapa (20-oct-2026). */}
                                    <Route path="/listados/archivo" element={<PermisoRoute permiso="listados.ver"><ListadoPlanillaHistorica key="ARCHIVO" origen="ARCHIVO" /></PermisoRoute>} />
                                    <Route path="/listados/carpetas-eliminadas" element={<PermisoRoute permiso="listados.ver"><ListadoPlanillaHistorica key="CARPETA_ELIMINADA" origen="CARPETA_ELIMINADA" /></PermisoRoute>} />
                                    <Route path="/listados/a-cobrar" element={<PermisoRoute permiso="listados.ver"><ListadoACobrar /></PermisoRoute>} />
                                    <Route path="/listados/altas" element={<PermisoRoute permiso="listados.ver"><ListadoAltas /></PermisoRoute>} />
                                    <Route path="/listados/deudores" element={<PermisoRoute permiso="listados.ver"><ListadoDeudores /></PermisoRoute>} />
                                    <Route path="/listados/a-liquidar" element={<PermisoRoute permiso="listados.ver"><ListadoALiquidar /></PermisoRoute>} />
                                    <Route path="/listados/para-aprobar" element={<PermisoRoute permiso="listados.ver"><ListadoParaAprobar /></PermisoRoute>} />

                                    {/* Reportes */}
                                    <Route path="/reportes/gastos" element={<ReportesGastos />} />
                                    <Route path="/reportes/tramites" element={<ReportesTramites />} />
                                    <Route path="/reportes/tramites/art" element={<ReportesTramitesART />} />
                                    <Route path="/reportes/tramites/rti" element={<ReportesTramitesRTI />} />
                                    <Route path="/reportes/referencias" element={<ReportesReferencias />} />
                                    {/* Reportes Recepción: vista simple por defecto, con acceso a Estadísticas Pro e Históricas */}
                                    <Route path="/reportes/recepcion" element={<ReportesRecepcion />} />
                                    <Route path="/reportes/recepcion/pro" element={<ReportesRecepcionPro />} />
                                    <Route path="/reportes/recepcion/historicas" element={<ReportesRecepcionHistoricas />} />
                                    <Route path="/reportes/recepcion/bot" element={<ReportesRecepcionBot />} />

                                    {/* Rutas de Administración */}
                                    <Route
                                        path="/admin/usuarios"
                                        element={
                                            <AdminRoute>
                                                <AdminUsuariosPage />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/whatsapp"
                                        element={
                                            <AdminRoute>
                                                <AdminWhatsAppPage />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/logs"
                                        element={
                                            <AdminRoute>
                                                <AdminLogsPage />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/datos-maestros"
                                        element={
                                            <PermisoRoute permiso={['datosMaestros.ver', 'datosMaestros.carpetas.ver']}>
                                                <AdminDatosMaestrosPage />
                                            </PermisoRoute>
                                        }
                                    />
                                    {/* Una página por lista; cuál puede ver cada usuario lo resuelve la propia página */}
                                    <Route
                                        path="/admin/datos-maestros/:clave"
                                        element={
                                            <PermisoRoute permiso={['datosMaestros.ver', 'datosMaestros.carpetas.ver']}>
                                                <AdminDatosMaestrosListaPage />
                                            </PermisoRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/backups"
                                        element={
                                            <AdminRoute>
                                                <GestionBackups />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/anses-search"
                                        element={
                                            <AdminRoute>
                                                <AdminAnsesSearchPage />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/email"
                                        element={
                                            <PermisoRoute permiso="correoExterno.ver">
                                                <AdminEmailPage />
                                            </PermisoRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/turnero"
                                        element={
                                            <RecepcionRoute>
                                                <ConfiguracionTurneroPage />
                                            </RecepcionRoute>
                                        }
                                    />

                                    {/* Redirigir cualquier ruta no encontrada dentro del área protegida a /home */}
                                    <Route path="*" element={<Navigate to="/home" replace />} />
                                </Routes>
                            </MainLayout>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </AuthProvider>
    );
}

export default App;